export { default as ourProcessSection } from "./ourProcess";
export { default as geotaggedProjectsSection } from "./geotaggedProjects";
export { default as featuredTestimonialSection } from "./featuredTestimonial";
export { default as embeddedVideoSection } from "./embeddedVideo";
export { default as iframeSection } from "./iframe";
export { default as projectsSection } from "./projects";
export { default as faqsSection } from "./faqs";
export { default as freeFormSection } from "./freeForm";
export { default as videoHeroSection } from "./videoHero";
export { default as homeHeroSection } from "./homeHero";
export { default as servicesSection } from "./services";
export { default as aboutSection } from "./about";
export { default as testimonialsSection } from "./testimonials";
export { default as offersSection } from "./offers";
export { default as mapSection } from "./map";
export { default as finalCTASection } from "./finalCTA";
export { default as contactFormSection } from "./contactForm";
export { default as aboutBenefitsAndAwardsSection } from "./aboutBenefitsAndAwards";
export { default as aboutFreeFormSection } from "./aboutFreeForm";
export { default as teamSection } from "./team";
export { default as serviceAreaMapSection } from "./serviceAreaMap";
export { default as serviceAreaHeroSection } from "./serviceAreaHero";
export { default as serviceHeroSection } from "./serviceHero";
export { default as serviceDetailsSection } from "./serviceDetails";
export { default as serviceProjectsSection } from "./serviceProjects";
export { default as navbarSection } from "./navbar";
export { default as serviceBenefitsSection } from "./serviceBenefits";
export { default as serviceAreaFreeFormSection } from "./serviceAreaFreeForm";
export { default as photoCarouselSection } from "./photoCarousel";
export { default as beforeAndAfterSection } from "./beforeAndAfter";
export { default as featuresSection } from "./features";
export { default as credentialsSection } from "./credentials";
export { default as textSection } from "./text";
export { default as partnershipsSection } from "./partnerships";

//ppc page sections
export { default as ppcHeroSection } from "./ppc/ppcHero";
export { default as ppcWhySection } from "./ppc/ppcWhy";
export { default as ppcOurProcessSection } from "./ppc/ppcOurProcess";
export { default as ppcTestimonialsSection } from "./ppc/ppcTestimonials";
export { default as ppcOfferingsSection } from "./ppc/ppcOfferings";
export { default as ppcServiceAreasSection } from "./ppc/ppcServiceAreas";
export { default as ppcFaqsSection } from "./ppc/ppcFaqs";
export { default as ppcCtaSection } from "./ppc/ppcCta";
